import { render, staticRenderFns } from "./szhzxCase.vue?vue&type=template&id=777ea862&scoped=true"
import script from "./szhzxCase.vue?vue&type=script&lang=js"
export * from "./szhzxCase.vue?vue&type=script&lang=js"
import style0 from "./szhzxCase.vue?vue&type=style&index=0&id=777ea862&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777ea862",
  null
  
)

export default component.exports